export type ButtonStateName = 'default' | 'saving' | 'saved' | 'failed' | 'unsaved' | 'loaded';
type ButtonStates = Record<ButtonStateName, string> & Record<string, string | undefined>;

export const buttonStates: ButtonStates = {
  default: 'btn-primary',
  saving: 'btn-info',
  saved: 'btn-success',
  failed: 'btn-danger',
  unsaved: 'btn-primary',
  loaded: 'btn-secondary',
};

export const buttonMessages: Record<string, string> = {};

buttonMessages[buttonStates.default] = 'Save';
buttonMessages[buttonStates.saving] = 'Saving...';
buttonMessages[buttonStates.saved] = 'Saved';
buttonMessages[buttonStates.failed] = 'Failed to save';
buttonMessages[buttonStates.unsaved] = 'Save';
buttonMessages[buttonStates.loaded] = 'Saved';
